<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="90rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.evaluatorList')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <div class="pop-cont02">
          <div class="form-group col-ty">
            <div class="form-row ty05">
              <div class="txt-tit ty04">{{t('message.autoMatchTarget')}}</div>
              <div class="row">
                <c-btn01 :btnText="t('message.autoMatchUpper')" class="sm" @click="onClickTargetSetting('up')"/>
                <c-btn01 :btnText="t('message.autoMatchLower')" class="sm" @click="onClickTargetSetting('down')"/>
              </div>
            </div>
          </div>
        </div>
        <v-card-text>
          <div class="tbl-group size-custom10">
            <v-data-table
              :headers="headers"
              :items="viewInfo.targetList"
              hide-default-footer
              return-object
            >
              <template v-slot:item="{ item }" >
                <tr class="v-data-table__tr">
                  <td>
                    <div class="txt-group">
                      <span class="t1">{{item.memberName}}</span>
                      <span class="t2">{{item.memberInfo??`${item.deptName}/${item.posName}`}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="txt-group">
                      <span class="t1">{{item.targetName}}</span>
                      <span class="t2">{{item.targetInfo??`${item.deptName}/${item.posName}`}}</span>
                    </div>
                  </td>
                  <td>
                    <BtnIcon class="btn-ico-set" @click="onClickSettingTarget(item)"/>
                  </td>
                  <td>
                    <BtnIcon class="btn-ico-delete" @click="onClickDeleteTarget(item)"/>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <div class="pop-cont03">
          <c-btnLine01 :btnText="t('message.addNew')" class="ty02" @click="onClickSettingTarget(null)"/>
        </div>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg">
          <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
          <c-btn01 :btnText="t('message.save')" @click="onClickSave"/>
        </v-card-actions>
      </v-card>
      <!--popup: 자동매칭-->
      <c-dialog v-model="dialogAutoMatchingModel"
                v-bind="dialogAutoMatchingBind"
                @close="dialogAutoMatchingModel=false"
                @confirm="confirmAuto"
      />
      <!--popup: 참여대상-->
      <DialogTargetAdd3 v-model="dialogTargetAdd3Model"
                        @close="dialogTargetAdd3Model=false"
                        @confirm="confirmTarget"
      />
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {useForm} from "vee-validate";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import LeadershipService from "@/services/leadership.service";
const { t } = useI18n();

const dialog = defineModel()
const emit = defineEmits(['close', 'confirm'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
})
const { validate } = useForm({ validationSchema: schema })

//bind
const viewInfo:any = ref({})
const dialogAutoMatchingModel = ref(false)
const dialogTargetAdd3Model = ref(false)
const snackbar = ref(false)
const snackText = ref('')
const popupItem:any = storeRef.leadershipMonitoringInfo
let autoFlag = ''

//ui
const headers = [
  { title: t('message.evaluator'), key: 'memberName' },
  { title: t('message.targetPerson'), key: 'targetName' },
  { title: t('message.update'), key: 'Change'},
  { title: t('message.delete'), key: 'Delete' }
]
const dialogAutoMatchingBind = {
  dialogTit: t('message.autoMatch'),
  dialogText: t('message.autoMatchResetWarning'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}

//hook
onUpdated (async() => {
  if (import.meta.env.MODE == 'development') {
    viewInfo.value.targetList = []
  } else {
    if (!dialog.value)
      return

    await getMonitoringTarget()
  }
})

//function
const getMonitoringTarget = async ()=>{
  const leadershipInfo:any = storeRef.leadershipInfo.value  //리더십 전체정보
  const monitoringInfo:any = storeRef.leadershipMonitoringInfo.value  //리더십 모니터링 전체정보
  try {
    viewInfo.value = {}
    let params={
      leadershipIdx:leadershipInfo.idx,
      companyIdx:localStorage.getItem('companyIdx'),
      monitoringIdx: popupItem.value.idx,
      monitoringType: '2',
      targetType: '2'
    }
    const response:any = await LeadershipService.getLeadershipMonitoringTargets(params)
    viewInfo.value = response.result
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickTargetSetting = async (type)=>{
  autoFlag = type
  dialogAutoMatchingModel.value=true
}

const confirmAuto=()=>{
  const leadershipInfo:any = storeRef.leadershipInfo.value  //리더십 전체정보
  const monitoringInfo:any = storeRef.leadershipMonitoringInfo.value  //리더십 모니터링 전체정보
  const popupType = storeRef.popupType.value  //대상역할, 관찰자 피관찰자
  let targetList = [] //모니터링 타겟정보
  let lastList = []
  //리더십 참여자들의 상,하위 맴버들 가지고 있음
  _.forEach(viewInfo.value.leadershipTargetList, (val, key)=> {
    if(autoFlag == 'up')
      targetList = val.parentMemberList
    else if(autoFlag == 'down')
      targetList = val.childMemberList

    _.forEach(targetList, (val2, key)=> {
      if(popupType == '1')
        lastList.push({memberIdx: val.idx, memberName: val.memberName, memberInfo: val.deptName+'/'+val.posName, targetMemberIdx: val2.idx,  targetName: val2.memberName, targetInfo: val2.deptName+'/'+val2.posName})
      else if(popupType == '2')
        lastList.push({memberIdx: val2.idx, memberName: val2.memberName, memberInfo: val2.deptName+'/'+val2.posName, targetMemberIdx: val.idx, targetName: val.memberName, targetInfo: val.deptName+'/'+val.posName})
    })
  })
  viewInfo.value.targetList = lastList
  if(lastList.length == 0){
    snackText.value = t('message.targetMissing')
    snackbar.value = true
  }
}

const confirmTarget=(item)=>{
  if(!_.some(viewInfo.value.targetList, {memberIdx:item.memberIdx, targetMemberIdx:item.targetMemberIdx})) {
    if(utils.isEmpty(viewInfo.value.targetList))
      viewInfo.value.targetList = [item]
    else {
      //변경으로 진입했으면 기존목록 제거
      if (storeRef.popupItems.value != null){
        _.remove(viewInfo.value.targetList, storeRef.popupItems.value)
        storeRef.popupItems.value = null
      }
      viewInfo.value.targetList.push(item)
    }
  }
}

const onClickSave=()=>{
  emit('confirm', viewInfo.value.targetList)
  dialog.value = false
}

const onClickSettingTarget=(item)=>{
  storeRef.popupItems.value = item
  dialogTargetAdd3Model.value=true
}

const onClickDeleteTarget=(item)=>{
  _.remove(viewInfo.value.targetList, storeRef.popupItems.value)
}
</script>


<style lang="scss" scoped>
</style>
